export const ROLES = {
    CHECKMATE: "CheckMate",
    ADMIN: "Admin",
    OFFICE: "Office",
    KITCHENUSER: "Kitchen User",
    ACCOUNTS: "Accounts",
}